import { Pipe, PipeTransform } from "@angular/core";
import { TimezoneService } from "../services/timezone.service";
import * as moment from 'moment-timezone';

@Pipe({ name: 'tzDate' })
export class TimezoneDatePipe implements PipeTransform {
  constructor(private timezoneService: TimezoneService) { }

  transform(
    value: Date | string | null | undefined,
    format = 'YYYY-MM-DD HH:mm',
    options: { utc?: boolean } = { utc: true }
  ): string {
    if (!value) return '';


    const tz = this.timezoneService.getCurrentTimezone();
    const useUtc = options.utc !== false;

    const momentDate = useUtc ? moment.utc(value) : moment(value);
    return momentDate.tz(tz).format(format);
  }
}